// 리다이렉트될 화면
// OAuth2RedirectHandeler.js

import React from 'react'
import { useDispatch } from 'react-redux'
import { connect } from 'react-redux'
import { alertActions, authActions, userinfoActions } from '../../store/actions'
import Alert from '../../module/alert/Alert'
import Loader from '../../module/loader'

const OAuth2RedirectHandler = (props) => {
  const dispatch = useDispatch()
  let userInfo = localStorage.getItem('user')
  // 인가코드
  let code = new URL(window.location.href).searchParams.get('code')

  React.useEffect(() => {
    if (userInfo !== null) {
      dispatch(userinfoActions.kakaoLogin(code)) //카카오 로그인 등록
    } else {
      dispatch(authActions.passkakaoLogin(code)) //카카오 로그인
    }
  }, [])

  /*   dispatch(alertActions.error({
    title: null,
    message: '8137'
  })) */

  return (
    <React.Fragment>
      {/* <Alert /> */}

      {/* container */}
      <div id="container">
        {/* contents */}
        <div id="contents">
          <div className="content-header">
            {/* <h2>인증서 관리</h2>
              <div className="breadcrumb">
                <span>Home</span>
                <span>마이페이지</span>
                <em>인증서 관리</em>
              </div>
            </div>
            <div className="cert-box">
              <dl>
                <dt>간편 로그인 설정</dt>
                <dd>
                  간편 로그인을 설정하시면, 연동된 계정으로 쉽고 빠른 로그인이
                  가능합니다.
                </dd>
              </dl> */}
          </div>
          {/* <div className="cert-gray-box mt20">
              <ul className="login-setup">
                <li>
                  <div className="box">
                    <i className="ico" />
                    <p>네이버 로그인</p>
                  </div>
                  <a href="#" className="btn-primary lg">
                    연동하기
                  </a>
                </li>
                <li>
                  <div className="box">
                    <i className="ico" />
                    <p>
                      카카오 로그인 <span>연동 일자 : 2022.00.00</span>
                    </p>
                  </div>
                  <a href="#" className="btn-secondary lg">
                    연동해제
                  </a>
                </li>
                <li>
                  <div className="box">
                    <i className="ico" />
                    <p>
                      디지털원패스 로그인 <span>연동 일자 : 2022.00.00</span>
                    </p>
                  </div>
                  <a href="#" className="btn-secondary lg disabled">
                    연동완료
                  </a>
                </li>
              </ul>
            </div> */}
        </div>
        {/* //contents */}
      </div>
      {/* //container */}
      <Loader />
    </React.Fragment>
  )
}
const mapStateToProps = (state) => {
  return {}
}
const actionCreators = {
  success: alertActions.success,
  error: alertActions.error,
  kakaoLogin: userinfoActions.kakaoLogin,
  passkakaoLogin: authActions.passkakaoLogin,
}
export default connect(mapStateToProps, actionCreators)(OAuth2RedirectHandler)
//export default OAuth2RedirectHandler;
